<div class="profile-info">
  <kds-avatar variant="image" size="medium" [firstName]="userFirstName()" [lastName]="userLastName()" />
  <div class="profile-info__content">
    <span
      #userFullNameElement
      class="profile-info__full-name"
      tooltipPosition="bottom-right"
      [kdsTooltip]="userFullName()"
      [disableTooltip]="!isTruncated(userFullNameElement)"
    >
      {{ userFullName() }}
    </span>
    <span
      #companyNameElement
      class="profile-info__company-name"
      tooltipPosition="bottom-right"
      [kdsTooltip]="organizationName()"
      [disableTooltip]="!isTruncated(companyNameElement)"
    >
      {{ organizationName() }}
    </span>
    <itc-email [email]="email()" />
  </div>
</div>
